import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Header1 from '@/components/Header1';

const formatContent = (content: string) => {
  return content.split('\n').map((paragraph, index) => (
    <p key={index} className="mb-4">{paragraph}</p>
  ));
};

const BlogPost = () => {
  const [blog, setBlog] = useState<{
    title: string;
    content: string;
    date: string;
    dateEdited?: string;
  } | null>(null);  
  const router = useRouter();
  const { slug } = router.query;

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(`/api/blog?slug=${slug}`);
        if (response.ok) {
          const data = await response.json();
          setBlog(data);
        } else {
          router.push('/404');
          console.error('Error fetching blog');
        }
      } catch (error) {
        console.error('Error fetching blog', error);
      }
    };

    if (slug) {
      fetchBlog();
    }
  }, [slug, router]);
  
  if (!blog) {
    return <div>Loading...</div>;
  }

  return (
    <main>
      <Head>
        <title>{blog.title} </title>
        <meta name="description" content="Buy cheap data bundles, airtime online for MTN, Glo, Airtel, and 9mobile, cable tv subscriptions, electricity bills payment, education pins. Swiftly process automated services from all service providers." />
        <meta name="keywords" content="cheap-data-bundles, buy-data, airtime, top-up, MTN, Glo, Airtel, 9mobile, etisalat, VTU, cable-tv, dstv, gotv, startimes, showmax, electricity-paymenets, prepaid-meter, postpaid-meter, ikedc, ekedc, aedc, kedco, phed, jed, kaedco, eedc, ibedc, bedc, education-payments, exam-pins, neco, waec, jamb, utme, nabteb" />
      </Head>

      <Header1 />

    <div className="max-w-2xl mx-auto mt-32">
      <h1 className="text-2xl text-iabcolour font-semibold mb-4">{blog.title}</h1>
      <div className="text-black bg-white p-6 shadow mb-6 rounded-lg">
        {formatContent(blog.content)}
        <p className="text-red-500">
          Created: {new Date(blog.date).toLocaleString()}
        </p>
        {blog.dateEdited && (
          <p className="text-gray-500">
            Edited: {new Date(blog.dateEdited).toLocaleString()}
          </p>
        )}
      </div>
    </div>

    </main>
  );
};

export default BlogPost;
